import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  alpha,
  CircularProgress,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import {
  Warning as WarningIcon,
  Delete as DeleteIcon,
  History as HistoryIcon,
  Star as RatingIcon,
  Favorite as LikeIcon,
  Restaurant as CookIcon,
} from "@mui/icons-material";

const DeleteConfirmationDialog = ({
  open,
  onClose,
  onConfirm,
  title,
  loading,
  recipeName,
}) => {
  return (
    <Dialog
      open={open}
      onClose={loading ? undefined : onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          p: 1,
        },
      }}
    >
      <DialogTitle sx={{ pb: 1 }}>
        <Box display="flex" alignItems="center" gap={1}>
          <WarningIcon color="error" />
          <Typography variant="h6" component="span">
            {title || "Delete Recipe"}
          </Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Typography color="error.main" gutterBottom fontWeight="medium">
          Warning: This action cannot be undone!
        </Typography>
        <Typography color="text.secondary" paragraph>
          Deleting "{recipeName}" will permanently remove:
        </Typography>
        <List dense>
          <ListItem>
            <ListItemIcon>
              <DeleteIcon color="error" />
            </ListItemIcon>
            <ListItemText primary="The recipe and all its contents" />
          </ListItem>
          <ListItem>
            <ListItemIcon>
              <HistoryIcon color="error" />
            </ListItemIcon>
            <ListItemText primary="All cooking history and statistics" />
          </ListItem>
          <ListItem>
            <ListItemIcon>
              <RatingIcon color="error" />
            </ListItemIcon>
            <ListItemText primary="All reviews and ratings" />
          </ListItem>
          <ListItem>
            <ListItemIcon>
              <LikeIcon color="error" />
            </ListItemIcon>
            <ListItemText primary="All likes and saves" />
          </ListItem>
          <ListItem>
            <ListItemIcon>
              <CookIcon color="error" />
            </ListItemIcon>
            <ListItemText primary="All cooking records" />
          </ListItem>
        </List>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          onClick={onClose}
          disabled={loading}
          sx={{
            color: "text.secondary",
            "&:hover": {
              bgcolor: (theme) => alpha(theme.palette.text.secondary, 0.08),
            },
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          disabled={loading}
          variant="contained"
          color="error"
          startIcon={loading && <CircularProgress size={20} color="inherit" />}
        >
          {loading ? "Deleting..." : "Yes, Delete Recipe"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmationDialog;
